import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';
import { getGameClientFrame } from '@/utilities/getters/getGameClientFrame';

export const sendGameWindowUIEnabled = (enabled: boolean) => {
  const gameClientFrame = getGameClientFrame();

  gameClientFrame?.contentWindow?.postMessage(
    {
      type: GAME_WINDOW_TO_CLIENT_EVENTS.GAME_WINDOW_UI_ENABLED,
      payload: enabled,
    },
    {
      targetOrigin: gameClientFrame.src,
    },
  );
};
